import React from "react";
import { DispatchProp } from "react-redux";
import { ThemeModel } from "../../models/ThemeModel";
import { NavigationType } from "../../models/enums/NavigationType";
import { ShortcutModel } from "../../models/ShortcutModel";
import { ShortcutExitToType } from "../../models/enums/ShortcutExitToType";
import NavigationBarRenderer from "../renderers/v2/NavigationBarRenderer";
import { navigationShortcut } from "../../redux/actions";

interface Props extends DispatchProp {
    shortcuts: ShortcutModel[];
    language: string;
    disabled: boolean;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    hideBackButton: boolean;
    theme: ThemeModel;
    position: "top" | "bottom";
    onNavigation(type: NavigationType): void;
}

export class Navigation extends React.PureComponent<Props, {}> {
    onNavigation = (type: NavigationType) => {
        const { disabled, onNavigation } = this.props;
        if (disabled) {
            return;
        }
        onNavigation(type);
    };

    onNavigateShortcut = (shortcut: ShortcutModel) => {
        const { dispatch } = this.props;
        dispatch(
            navigationShortcut(
                shortcut.blockName,
                shortcut.type === ShortcutExitToType.NextQuestion,
            ),
        );
    };

    render() {
        const {
            theme,
            shortcuts,
            disabled,
            hasPreviousPage,
            hasNextPage,
            hideBackButton,
            position,
        } = this.props;
        return (
            <NavigationBarRenderer
                position={position}
                surveyTheme={theme}
                hasPreviousPage={hasPreviousPage}
                hasNextPage={hasNextPage}
                hideBackButton={hideBackButton}
                shortcuts={shortcuts}
                onNavigateShortcut={this.onNavigateShortcut}
                onNavigation={this.onNavigation}
                disabled={disabled}
            />
        );
    }
}
